import { db } from "../../../firebase";
import { ref, query, orderByChild, orderByKey, limitToFirst, startAfter, startAt, endAt, get, set, remove } from "firebase/database";
// let lastKey = null; // ← FIXED

// export async function getSongsPage(pageNumber, pageSize = 25) {
//   const songsRef = ref(db, "songs");

//   if (pageNumber === 1) {
//     lastKey = null;
//   }

//   let q;

//   if (!lastKey) {
//     q = query(songsRef, orderByKey(), limitToFirst(pageSize));
//   } else {
//     q = query(songsRef, orderByKey(), startAfter(lastKey), limitToFirst(pageSize));
//   }

//   const snapshot = await get(q);

//   if (!snapshot.exists()) return [];

//   const data = snapshot.val();
//   const keys = Object.keys(data);

//   // update lastKey for next page
//   lastKey = keys[keys.length - 1];

//   // convert to array
//   return keys.map((id) => ({
//     id,
//     ...data[id],
//   }));
// }

// export async function getSongCount() {
//   const snap = await get(ref(db, "songs"));
//   if (!snap.exists()) return 0;
//   return Object.keys(snap.val()).length;
// }

let lastKey = null;

export async function getSongsPage(pageNumber, pageSize = 25, search = "") {
  const songsRef = ref(db, "songs");
  console.log("triggered",search)

  if (search.trim() !== "") {
    const searchLower = search;
    // const searchLower = search.toLowerCase();

    const q = query(
      songsRef,
      orderByChild("titleEN"),
      startAt(searchLower),
      endAt(searchLower + "\uf8ff")
    );

    const snap = await get(q);
    if (!snap.exists()) return [];

    return Object.keys(snap.val()).map((id) => ({
      id,
      ...snap.val()[id],
    }));
  }

  if (pageNumber === 1) {
    lastKey = null;
  }

  let q;

  if (!lastKey) {
    q = query(songsRef, orderByKey(), limitToFirst(pageSize));
  } else {
    q = query(songsRef, orderByKey(), startAfter(lastKey), limitToFirst(pageSize));
  }

  const snapshot = await get(q);
  if (!snapshot.exists()) return [];

  const data = snapshot.val();
  const keys = Object.keys(data);

  lastKey = keys[keys.length - 1];

  return keys.map((id) => ({
    id,
    ...data[id],
  }));
}

export async function getSongCount(search = "") {
  const songsRef = ref(db, "songs");

  if (search.trim() !== "") {
    // const searchLower = search.toLowerCase();
    const searchLower = search;

    const q = query(
      songsRef,
      orderByChild("titleEN"),
      startAt(searchLower),
      endAt(searchLower + "\uf8ff")
    );

    const snap = await get(q);
    if (!snap.exists()) return 0;

    return Object.keys(snap.val()).length;
  }

  const snap = await get(songsRef);
  if (!snap.exists()) return 0;

  return Object.keys(snap.val()).length;
}

export async function upsertSong(oldTitle, songData) {
  const newTitle = songData.titleEN;

  if (oldTitle && oldTitle !== newTitle) {
    await remove(ref(db, `songs/${oldTitle}`));
  }
  await set(ref(db, `songs/${newTitle}`), songData);

  return true;
}


export async function createSong(songData) {
  const songRef = ref(db, `songs/${songData.titleEN}`);

  await set(songRef, {
    keywords: songData.keywords,
    lyricsKAN: songData.lyricsKAN,
    lyricsTAM: songData.lyricsTAM,
    song_num: songData.song_num,
    titleEN: songData.titleEN,
    titleKAN: songData.titleKAN,
    titleTAM: songData.titleTAM
  });

  return true;
}


export async function deleteSong(titleEN) {
  if (!titleEN) throw new Error("titleEN is required");
  const songRef = ref(db, `songs/${titleEN}`);
  await remove(songRef);
  return true;
}